import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Grid, Stepper, Step, StepLabel, RadioGroup, MenuItem, Radio, FormControlLabel, Typography, Card, Button, Table, TableBody, TableHead, TableRow, TableCell, Dialog, DialogContent, DialogActions, Toolbar, CardContent } from '@mui/material';
import Config from '../../config';
import Helpers, { triggerSubmit } from '../../helpers';
import { Form as FormBase, Field as FieldBase } from 'react-final-form';
import DropZone from '../files/dropzone';
import TextField from '../../components/text_field';
import DownloadButton from '../../components/download_button';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ConfirmDialog from '../../components/confirm_dialog';
import SelectField from '../../components/select_field';
import Auth from '../../auth';
import ContentLoader from '../../components/content_loader';
import { ErrorOutline as LoadErrorIcon } from '@mui/icons-material';
import { formatContact } from '../../components/address'
import moment from 'moment';

// react-final-form's Form/Field generics don't line up with this file's loose
// value shapes; cast to any at the import boundary (established pattern, see
// reports.tsx/scorecards.tsx).
const Form: any = FormBase;
const Field: any = FieldBase;

const processAccountInfo = (accountInfo: any) => {
    if(accountInfo.RepresentativeBirthday){
        accountInfo.RepresentativeBirthday = moment(accountInfo.RepresentativeBirthday).format('YYYY-MM-DD');
    }
    accountInfo.statusCode = 500;
    if(accountInfo.ValidationLevel === 'Validated'){
        accountInfo.statusCode = 1000;
    }
    return accountInfo;
}

type SubFormProps = {
    onSubmit: (values: any) => void;
    values?: any;
    formRef?: (ref: any) => void;
};

const CompanyInfoForm = (props: SubFormProps) => {
    let {onSubmit, values, formRef} = props;
    return <div>
    <Form
        onSubmit={onSubmit}
        initialValues={values}
        render={({ handleSubmit, pristine, invalid, values }: any) => (
          <form onSubmit={handleSubmit} ref={formRef}>
                <Field style={{width: '100%'}} name='Name' label='Company name' component={TextField}/>
                <Field style={{width: '100%'}} name='CompanyNumber' label='Company number' component={TextField}/>
                <Field style={{width: '100%'}} formControlProps={{style: {width: '100%'}}} shrink name='CompanyType' label='Company type' component={SelectField}>
                    <MenuItem value='AssociationIncorporated'>Association</MenuItem>
                    <MenuItem value='GovernmentalOrganization'>Governmental organization</MenuItem>
                    <MenuItem value='ListedPublicCompany'>Listed public company</MenuItem>
                    <MenuItem value='NonProfit'>Nonprofit</MenuItem>
                    <MenuItem value='PartnershipIncorporated'>Partnership</MenuItem>
                    <MenuItem value='PrivateCompany'>Private</MenuItem>
                </Field>
                <Field style={{width: '100%'}} name='TaxId' label='Tax ID' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.Phone' label='Phone' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.Email' label='Email' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.Address1' label='Line 1' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.Address2' label='Line 2' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.City' label='City' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.State' label='State' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.Zip' label='Postal code' component={TextField}/>
                <Field style={{width: '100%'}} name='Company.Country' label='Country' component={TextField}/>
          </form>)}/>
    </div>
}

const RepresentativeForm = (props: SubFormProps) => {
    let {onSubmit, values, formRef} = props;
    return <div>
    <Form
        onSubmit={onSubmit}
        initialValues={values}
        render={({ handleSubmit, pristine, invalid, values }: any) => (
          <form onSubmit={handleSubmit} ref={formRef}>
              <Field style={{width: '100%'}} name='Representative.FirstName' label='First name' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.LastName' label='Last name' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.Email' label='Email' component={TextField}/>
              <Field style={{width: '100%'}} name='RepresentativeNationality' label='Nationality' component={TextField}/>
              <Field style={{width: '100%'}} name='RepresentativeCountryOfResidence' label='Country of residence' component={TextField}/>
              <Field style={{width: '100%'}} name='RepresentativeBirthday' label='Date of birth' type='date' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.Address1' label='Line 1' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.Address2' label='Line 2' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.City' label='City' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.State' label='State' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.Zip' label='Postal code' component={TextField}/>
              <Field style={{width: '100%'}} name='Representative.Country' label='Country' component={TextField}/>
          </form>)}/>
    </div>
}

type UboFormProps = SubFormProps & { prefix: string };

const UboForm = (props: UboFormProps) => {
    let {onSubmit, values, formRef, prefix} = props;
    return <div>
    <Form
        onSubmit={onSubmit}
        initialValues={values}
        render={({ handleSubmit, pristine, invalid, values }: any) => (
          <form onSubmit={handleSubmit} ref={formRef}>
              <Field style={{width: '100%'}} formControlProps={{style: {width: '100%'}}} shrink name={`${prefix}.Type`} label='Beneficiary type' component={SelectField}>
                  <MenuItem value=''>None</MenuItem>
                  <MenuItem value='Controller'>Controller</MenuItem>
                  <MenuItem value='Owner'>Owner</MenuItem>
                  <MenuItem value='Signatory'>Signatory</MenuItem>
              </Field>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.FirstName`} label='First name' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.LastName`} label='Last name' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.Email`} label='Email' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.Phone`} label='Phone' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.JobTitle`} label='Job title' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Nationality`} label='Nationality' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.BirthCountry`} label='Birth country' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.BirthCity`} label='Birth city' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Birthday`} label='Date of birth' type='date' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.Address1`} label='Line 1' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.Address2`} label='Line 2' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.City`} label='City' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.State`} label='State' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.Zip`} label='Postal code' component={TextField}/>
              <Field style={{width: '100%'}} name={`${prefix}.Contact.Country`} label='Country' component={TextField}/>
          </form>)}/>
    </div>
}

const BankAccountOwnerForm = (props: SubFormProps) => {
    let {onSubmit, values, formRef} = props;
    return <div>
    <Form
        onSubmit={onSubmit}
        initialValues={values}
        render={({ handleSubmit, pristine, invalid, values }: any) => (
          <form onSubmit={handleSubmit} ref={formRef}>
              <Field style={{width: '100%'}} name={`OwnerAddress.FirstName`} label='First name' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.LastName`} label='Last name' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.Address1`} label='Line 1' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.Address2`} label='Line 2' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.City`} label='City' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.State`} label='State' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.Zip`} label='Postal code' component={TextField}/>
              <Field style={{width: '100%'}} name={`OwnerAddress.Country`} label='Country' component={TextField}/>
          </form>)}/>
    </div>
}

const BankAccountForm = (props: SubFormProps) => {
    let {onSubmit, values, formRef} = props;
    const accountNumberLabel = (type: string) => {
        if(type === 'IBAN'){
            return 'IBAN';
        }
        return 'Account number';
    }
    const bankIdLabel = (type: string) => {
        if(type === 'GB'){
            return 'Sort code';
        }
        if(type === 'US'){
            return 'ABA';
        }
        if(type === 'CA'){
            return 'Institution number';
        }
        return 'BIC';
    }
    return <div>
    <Form
        onSubmit={onSubmit}
        initialValues={values}
        render={({ handleSubmit, pristine, invalid, values }: any) => (
          <form onSubmit={handleSubmit} ref={formRef}>
              <Field formControlProps={{style: {width: '100%'}}} name={`Type`} label='Type' component={SelectField}>
                  <MenuItem value='IBAN'>IBAN</MenuItem>
                  <MenuItem value='GB'>GB</MenuItem>
                  <MenuItem value='US'>US</MenuItem>
                  <MenuItem value='CA'>CA</MenuItem>
                  <MenuItem value='OTHER'>Other</MenuItem>
              </Field>
              <Field style={{width: '100%'}} name={`AccountNumber`} label={accountNumberLabel(values.Type)} component={TextField}/>
              <Field style={{width: '100%'}} name={`BankId`} label={bankIdLabel(values.Type)} component={TextField}/>
              {values.Type === 'CA' && <>
              <Field style={{width: '100%'}} name={`BranchCode`} label={'Branch code'} component={TextField}/>
              <Field style={{width: '100%'}} name={`BankName`} label={'Bank name'} component={TextField}/>
              </>}
              <Field style={{width: '100%'}} name={`BankCountry`} label={'Bank country'} component={TextField}/>
          </form>)}/>
    </div>
}

type AccountInfoProps = {
    account: any;
    editAccountInfo?: () => void;
    partnerName?: string;
};

const AccountInfo = (props: AccountInfoProps) => {
    let {account, editAccountInfo, partnerName} = props;
    // Guard the whole account object: when a partner has no payment account set up, the
    // parent renders this with an undefined account, and `account.statusCode` /
    // initialValues={account} threw "Cannot read properties of undefined (reading
    // 'statusCode')" on mount, crashing /payments/account.
    account = account || {};
    return <Card>
        <Toolbar className='lbtoolbar'><span style={{flex: 1, textAlign: 'left'}}>{'Account Details'}{!(!partnerName) && (' for ' + partnerName)}</span>{!(!editAccountInfo) &&<Button onClick={editAccountInfo} style={{color: 'white'}}>Edit</Button>}</Toolbar>
        <Toolbar className='lbstatusbar statusColor' {...({statuscode: account.statusCode} as any)}>Validation level: {account.ValidationLevel}</Toolbar>
        <CardContent>
            <div style={{display: 'flex', flex: '1', flexDirection: 'column'}}>
            <Form
                initialValues={account}
                onSubmit={() => {}}
                render={() => (
                  <form>
                        <Field style={{width: '100%'}} disabled name='ExternalAccountId' label='Account number' component={TextField}/>
                        <Field style={{width: '100%'}} disabled name='ExternalWalletId' label='Balance account number' component={TextField}/>
                        <Field style={{width: '100%'}} disabled name='Name' label='Company name' component={TextField}/>
                        <Field style={{width: '100%'}} disabled name='CompanyNumber' label='Company number' component={TextField}/>
                        <FormControl style={{width: '100%'}}>
                            <InputLabel shrink>Headquarters</InputLabel>
                            <div style={{whiteSpace: 'pre', textAlign: 'left', marginTop: "16px", padding: "6px 0 7px"}}>{formatContact(account.Company || {})}</div>
                        </FormControl>
                        <FormControl style={{width: '100%'}}>
                            <InputLabel shrink>Legal representative</InputLabel>
                            <div style={{whiteSpace: 'pre', textAlign: 'left', marginTop: "16px", padding: "6px 0 7px"}}>{formatContact(account.Representative || {})}</div>
                        </FormControl>
                        <Field style={{width: '100%'}} disabled name='RepresentativeNationality' label='Representative nationality' component={TextField}/>
                        <Field style={{width: '100%'}} disabled name='RepresentativeCountryOfResidence' label='Representative country of residence' component={TextField}/>
                        <Field style={{width: '100%'}} disabled name='RepresentativeBirthday' label='Representative date of birth' type='date' component={TextField}/>
                  </form>)}/>
            </div>
        </CardContent>
    </Card>;
}

type DocumentInfoProps = {
    documents: any[];
    uploadKyc?: () => void;
};

const DocumentInfo = (props: DocumentInfoProps) => {
    let {documents, uploadKyc} = props;
    return <Card>
        <Toolbar className='lbtoolbar'><span style={{flex: 1, textAlign: 'left'}}>{'KYC Documents'}</span>{!(!uploadKyc) && <Button onClick={uploadKyc} style={{color: 'white'}}>Upload</Button>}</Toolbar>
        <CardContent>
        <Table>
         <TableHead>
            <TableRow>
             <TableCell style={{width: '10em'}}>Type</TableCell>
             <TableCell style={{width: '10em'}}>Status</TableCell>
             <TableCell>Message</TableCell>
            </TableRow>
         </TableHead>
         <TableBody>
             {documents.map((name, index) => <TableRow key={index}>
                 <TableCell>{documents[index].Type}</TableCell>
                 <TableCell>{documents[index].Status}</TableCell>
                 <TableCell>{documents[index].Message}</TableCell>
             </TableRow>)}
             {documents.length === 0 && <TableRow><TableCell colSpan={2}>Please upload a document to begin verification.</TableCell></TableRow>}
         </TableBody>
        </Table>
        </CardContent>
    </Card>;
}

type UboInfoProps = {
    ubo: any;
    editUbo?: () => void;
};

const UboInfo = (props: UboInfoProps) => {
    let {ubo, editUbo} = props;
    // Same guard as AccountInfo: a partner with no beneficiary declaration renders this
    // with an undefined ubo, and `ubo.Status` threw on mount. Default to {} (line below
    // already does Object.keys(ubo || {})).
    ubo = ubo || {};
    return <Card>
        <Toolbar className='lbtoolbar'><span style={{flex: 1, textAlign: 'left'}}>Ultimate Beneficiary Declaration</span>{!(!editUbo) && <Button onClick={editUbo} style={{color: 'white'}}>Edit</Button>}</Toolbar>
        {ubo.Status && <Toolbar className='lbstatusbar statusColor' {...({statuscode: ubo.statusCode} as any)}>Status: {ubo.Status}</Toolbar>}
        <CardContent style={{textAlign: 'left'}}>
            {Object.keys(ubo || {}).length === 0 && 'There is no ultimate beneficiary declaration set up. You must declare individuals that own 25% or more of the company or the legal representative if there are no such owners.'}
            <Table>
             <TableHead>
                <TableRow>
                 <TableCell>Beneficiary</TableCell>
                </TableRow>
             </TableHead>
             <TableBody>
                 {(ubo.Beneficiaries || []).map((name: any, index: number) => <TableRow key={index}>
                     <TableCell>{formatContact(ubo.Beneficiaries[index].Contact)}</TableCell>
                 </TableRow>)}
                 {(ubo.Beneficiaries || []) === 0 && <TableRow><TableCell colSpan={2}>No beneficiaries declared.</TableCell></TableRow>}
             </TableBody>
            </Table>
        </CardContent>
    </Card>;
}

// PaymentSettings drives a large multi-step wizard (account info, KYC
// documents, UBO declaration, bank accounts) where nearly every step handler
// adds its own transient state keys (accountInfoCopy, continueLoading,
// uboCopy, bankAccount, docOptions, editorTitle, confirmContent,
// handleConfirm, etc.) well beyond the initial state literal below. Typed
// `any` throughout rather than enumerating every wizard-step field (same
// approach as edi.tsx's EdiSettings and reports.tsx's Chart/Widget).
//
// The former class kept a single `any` state bag mutated via partial-merge
// this.setState({...}) and read this.state at call time (including after
// awaits). To preserve that "always-latest read + partial merge" semantics in
// hooks without stale-closure hazards, state lives in a ref (`stateRef`) that
// is kept in sync inside the merge updater; imperative handlers read
// `stateRef.current`, while render reads the reactive `state` value.
const PaymentSettings = (props: any) => {
    const [state, setStateRaw] = useState<any>({ partner: null, accountSetup: true, showEditor: false, showError: false, steps: [], activeStep: 0, documents: [], uploadType: '', entityType: 'Company', showConfirm: false, files: [] });
    const stateRef = useRef<any>(state);
    const setState = (partial: any) => {
        const next = { ...stateRef.current, ...partial };
        stateRef.current = next;
        setStateRaw(next);
    };
    // Assigned via the wizard forms' `formRef` callback below; there is only
    // ever one active step form at a time, so a single reused ref mirrors the
    // original implicit instance-field behavior.
    const stepFormRef = useRef<any>(null);

    const loadUbo = async (partner: string) => {
        let declaration = (await axios.get(Config.api + `/api/v1/payment/${partner}/BeneficiaryDeclaration`)).data;
        if(declaration.Beneficiaries){
            declaration.Beneficiaries.forEach((r: any) => {
                if(r.Birthday){
                    r.Birthday = moment(r.Birthday).format('YYYY-MM-DD')
                }
            });
        }
        declaration.statusCode = 500;
        if(declaration.Status === 'Refused' ){
            declaration.statusCode = 1200;
        } else if (declaration.Status === 'Validated'){
            declaration.statusCode = 1000;
        }
        return declaration;
    }
    const loadDocuments = async (partner: string) => {
        return (await axios.get(Config.api + `/api/v1/payment/${partner}/documents`)).data;
    }
    const loadBankAccounts = async (partner: string) => {
        return (await axios.get(Config.api + `/api/v1/payment/${partner}/bankaccounts`)).data;
    }
    const loadData = async (partner: string) => {
        if(!partner){
            return;
        }
        let docOptions: any[] = [];
        docOptions.push({label: "Company", value: "Company", id: null, type: null, description: "Company-wide documents like registration forms."});
        let accountInfo: any = {};
        try{
            accountInfo = (await axios.get(Config.api + `/api/v1/payment/${partner}/account`)).data;
            accountInfo = processAccountInfo(accountInfo);
        }catch(e: any){
            if(e.response && e.response.status === 404){
                setState({accountInfo: {}, loaded: true, loadError: null, accountSetup: false, steps: allSteps, activeStep: 0, docOptions});
                return;
            }
            let loadError = 'This company does not support automated payments.';
            if(e.response && e.response.status === 500){
                loadError = 'There was an error communicating with the payment provider.';
            }
            setState({loaded: true, loadError, docOptions, accountSetup: false, accountInfo: {}, documents: [], ubo: {}, bankAccounts: []});
            return;
        }
        let documents = await loadDocuments(partner);

        let ubo: any = {};
        try {
            ubo = await loadUbo(partner);
        }catch(e){
            // do nothing
        }
        let bankAccounts = await loadBankAccounts(partner);
        if(ubo.Beneficiaries){
            ubo.Beneficiaries.forEach((r: any, i: number) => {
                if(r.Id){
                    docOptions.push({label: "Beneficiary #"+(i+1), id: r.Id, value: 'Beneficiary'+i, type: 'Beneficiary', description: "Documentation for an individual beneficiary."});
                }
            });
        }
        if(bankAccounts){
            bankAccounts.forEach((r: any, i: number) => {
                if(r.Id){
                    docOptions.push({label: "Bank account #"+(i+1), id: r.Id, type: 'BankAccount', value: 'BankAccount'+i, description: "Documentation for a bank account."});
                }
            });
        }
        setState({accountInfo: accountInfo, loaded: true, loadError: null, documents, ubo, bankAccounts, accountSetup: true, docOptions});
    }
    const onDrop = (files: any[]) => {
        if(!files || !files.length){
            return;
        }
        files = [...stateRef.current.files, ...files];
        setState({files: files});
    }
    const submitCompanyInfo = async (e: any) => {
        setState({accountInfoCopy: e, activeStep: stateRef.current.activeStep + 1});
    }
    const saveAccountInfo = async (e: any) => {
        try{
            e = Object.assign({}, e);
            if(e.RepresentativeBirthday){
                e.RepresentativeBirthday = moment(e.RepresentativeBirthday).format('YYYY-MM-DDT00:00:00Z')
            }
            let resp = (await axios.put(Config.api + `/api/v1/payment/${stateRef.current.partner}/account`, e)).data;
            resp = processAccountInfo(resp);
            let newState: any = {accountInfo: resp, continueLoading: false};
            if(stateRef.current.activeStep === stateRef.current.steps.length - 1){
                newState.showEditor = false;
            }
            if(stateRef.current.activeStep < stateRef.current.steps.length - 1){
                newState.activeStep = stateRef.current.activeStep + 1;
            }
            setState(newState);
        }catch(e: any){
            let error = "Failed to save account information.";
            if(e.response && e.response.data){
                error = new Helpers().getApiErrors(e.response.data).join("\n");
            }
            setState({showError: true, error, continueLoading: false});
        }
    }
    const updateUbo = async (e: any) => {
        if(stateRef.current.steps[stateRef.current.activeStep].id !== uboSteps[uboSteps.length - 1].id){
            setState({uboCopy: e, activeStep: stateRef.current.activeStep + 1});
            return;
        }
        setState({continueLoading: true});
        try{
            e = Object.assign({}, e);
            if(!e.Beneficiaries){
                e.Beneficiaries = [];
            }
            e.Beneficiaries = e.Beneficiaries.filter((r: any) => Object.values(r).some(x => x !== null && x !== ''));
            e.Beneficiaries.forEach((r: any) => {
                if(r.Birthday){
                    r.Birthday = moment(r.Birthday).format('YYYY-MM-DDT00:00:00Z')
                }
            });
            await axios.post(Config.api + `/api/v1/payment/${stateRef.current.partner}/beneficiarydeclaration`, e);
            let ubo = await loadUbo(stateRef.current.partner);
            let newState: any = {ubo, continueLoading: false, showEditor: false};
            if(stateRef.current.activeStep < stateRef.current.steps.length - 1){
                newState.activeStep = stateRef.current.activeStep + 1;
            }
            setState(newState);
        }catch(e: any){
            let error = "Failed to save beneficiary declaration.";
            if(e.response && e.response.data){
                error = new Helpers().getApiErrors(e.response.data).join("\n");
            }
            setState({showError: true, error, continueLoading: false});
        }
    }
    const updateBankAccount = async (e: any) => {
        if(stateRef.current.steps[stateRef.current.activeStep].id !== bankAccountSteps[bankAccountSteps.length - 1].id){
            setState({bankAccount: e, activeStep: stateRef.current.activeStep + 1});
            return;
        }
        setState({continueLoading: true});
        try{
            e = Object.assign({}, e);
            await axios.post(Config.api + `/api/v1/payment/${stateRef.current.partner}/bankaccounts`, e);
            let bankAccounts = await loadBankAccounts(stateRef.current.partner);
            let newState: any = {bankAccounts, continueLoading: false, showEditor: false};
            if(stateRef.current.activeStep < stateRef.current.steps.length - 1){
                newState.activeStep = stateRef.current.activeStep + 1;
            }
            setState(newState);
        }catch(e: any){
            let error = "Failed to create bank account.";
            if(e.response && e.response.data){
                error = new Helpers().getApiErrors(e.response.data).join("\n");
            }
            setState({showError: true, error, continueLoading: false});
        }
    }
    const uploadFiles = async () => {
        let formData = new FormData();
        stateRef.current.files.forEach((r: any) => formData.append("file", r));
        let docOption = stateRef.current.docOptions.find((r: any) => r.value === stateRef.current.entityType);
        let suffix = '';
        if(docOption){
            suffix = "&entityId=" + docOption.id;
            if(docOption.type){
                suffix += "&entityType=" + docOption.type;
            }
        }
        try{
            await axios.post(Config.api + `/api/v1/payment/${stateRef.current.partner}/documents?documentType=${stateRef.current.uploadType}` + suffix, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
              }
            });
            let documents = await loadDocuments(stateRef.current.partner);
            let newState: any = {documents, continueLoading: false, uploadType: ''};
            if(stateRef.current.activeStep < stateRef.current.steps.length - 1){
                newState.activeStep = stateRef.current.activeStep + 1;
            } else {
                newState.showEditor = false;
            }
            setState(newState);
        }catch(e: any){
            let error = "Failed to upload files.";
            if(e.response && e.response.data){
                error = new Helpers().getApiErrors(e.response.data).join("\n");
            }
            setState({showError: true, error, continueLoading: false});
        }
    }
    const deactivateBankAccount = async (account: any, confirm?: boolean) => {
        if(!confirm){
            setState({showConfirm: true, confirmContent: 'Are you sure you want to remove this bank account?', handleConfirm: () => deactivateBankAccount(account, true)});
            return;
        }
        try{
            await axios.delete(Config.api + `/api/v1/payment/${stateRef.current.partner}/bankaccounts/${account}`);
            let bankAccounts = await loadBankAccounts(stateRef.current.partner);
            setState({showConfirm: false, bankAccounts});
        }catch(e: any){
            let error = "Failed to deactivate account.";
            if(e.response && e.response.data){
                error = new Helpers().getApiErrors(e.response.data).join("\n");
            }
            setState({showError: true, error, showConfirm: false});
        }
    }
    const editAccountInfo = () => {
        let accountInfoCopy = JSON.parse(JSON.stringify(stateRef.current.accountInfo));
        setState({steps: accountInfoSteps,
            editorTitle: 'Edit Account Information',
            activeStep: 0,
            accountInfoCopy,
            showEditor: true
        });
    }
    const uploadKyc = () => {
        setState({steps: documentUploadSteps,
            editorTitle: 'Upload Documents',
            activeStep: 0,
            showEditor: true,
            uploadType: '',
            files: []
        });
    }
    const newBankAccount = () => {
        setState({steps: bankAccountSteps,
            editorTitle: 'New Bank Account',
            activeStep: 0,
            bankAccount: {Type: 'IBAN'},
            showEditor: true
        });
    }
    const editUbo = () => {
        let uboCopy = JSON.parse(JSON.stringify(stateRef.current.ubo));
        setState({steps: uboSteps,
            editorTitle: 'Edit Beneficiary Declaration',
            activeStep: 0,
            uboCopy,
            showEditor: true
        });
    }

    const accountInfoSteps = [{id: "Company Information",
        content: () => <CompanyInfoForm formRef={(r: any) => stepFormRef.current = r} onSubmit={submitCompanyInfo} values={stateRef.current.accountInfoCopy}/>,
        onNext: () => {
            triggerSubmit(stepFormRef.current);
            return false;
        }
    },
    {id: "Legal Representative",
        content: () => <RepresentativeForm formRef={(r: any) => stepFormRef.current = r} onSubmit={saveAccountInfo} values={stateRef.current.accountInfoCopy}/>,
        onNext: () => {
            setState({continueLoading: true});
            triggerSubmit(stepFormRef.current);
            return false;
        },
        submitIfNotNext: true
    }];
    const documentUploadSteps = [{id: 'Choose Document Type',
        content: () => <div><Typography>What type of file would you like to upload?</Typography>
          <RadioGroup
            aria-label="Document Type"
            name="fileType"
            value={stateRef.current.uploadType}
            onChange={(e, value) => {setState({uploadType: value})}}
          >
            <FormControlLabel value="Identity" control={<Radio />} label={<><span>Identity proof</span><div><Typography color='textSecondary'>Proof of the legal representative's identity. Examples: passport, driver's license, identity card.</Typography></div></>} />
            <FormControlLabel value="Registration" control={<Radio />} label={<><span>Registration proof</span><div><Typography color='textSecondary'>Business registration document.</Typography></div></>} />
            <FormControlLabel value="Association" control={<Radio />} label={<><span>Association proof</span><div><Typography color='textSecondary'>Signed articles of association.</Typography></div></>} />
            <FormControlLabel value="Bank Statement" control={<Radio />} label={<><span>Bank statement</span><div><Typography color='textSecondary'>A document issued by your bank containing the account holder's name, account number, date of issuance and country if applicable.</Typography></div></>} />
          </RadioGroup></div>
      },
      {id: 'Choose Related Entity',
          content: () => <div><Typography>Who or what is this document linked to?</Typography>
            <RadioGroup
              aria-label="Entity Type"
              name="fileType"
              value={stateRef.current.entityType}
              onChange={(e, value) => {setState({entityType: value})}}
            >
                {stateRef.current.docOptions.map((r: any) => <FormControlLabel key={r.value} value={r.value} control={<Radio />} label={<><span>{r.label}</span><div><Typography color='textSecondary'>{r.description}</Typography></div></>} />)}
            </RadioGroup></div>
        },
      { id: 'Upload Files',
        content: () => <>
            <DropZone accept="image/jpeg,image/png,application/pdf" style={{width: '100%', height: '5em', padding: '10px'}} onDrop={onDrop}>
            {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }: any) => {
                if (isDragAccept) {
                  return "Drop here to upload this file.";
                }
                if(isDragReject){
                    return "This is not a valid file type.";
                }
                if(stateRef.current.files.length > 0){
                    return stateRef.current.files.map((r: any) => r.name).join(', ');
                }

                return "Drop a file here or click to choose a file. You may upload multiple files at once (for example, front and back of a driver's license).";
              }}
            </DropZone>
        </>,
        onNext: async () => {
            setState({continueLoading: true});
            await uploadFiles();
            return true;
        },
        submitIfNotNext: true
      }
    ];
    const uboSteps = [0, 1, 2, 3].map(u => ({id: `Beneficiary ${u + 1}`,
        content: () => <UboForm formRef={(r: any) => stepFormRef.current = r} prefix={`Beneficiaries[${u}]`} onSubmit={updateUbo} values={stateRef.current.uboCopy}/>,
        onNext: () => {
            triggerSubmit(stepFormRef.current);
            return false;
        },
        submitIfNotNext: true
    }));
    const bankAccountSteps = [{id: `Bank Account`,
        content: () => <BankAccountForm formRef={(r: any) => stepFormRef.current = r} onSubmit={updateBankAccount} values={stateRef.current.bankAccount}/>,
        onNext: () => {
            triggerSubmit(stepFormRef.current);
            return false;
        }
    },
    {id: `Bank Account Owner`,
        content: () => <BankAccountOwnerForm formRef={(r: any) => stepFormRef.current = r} onSubmit={updateBankAccount} values={stateRef.current.bankAccount}/>,
        onNext: () => {
            triggerSubmit(stepFormRef.current);
            return false;
        },
        submitIfNotNext: true
    }];
    const allSteps = [{id: 'Welcome', content: 'Welcome to the Logicbroker payment provider system! To begin configuring your account please press continue.'},
        ...accountInfoSteps,
        ...documentUploadSteps,
        ...uboSteps,
        ...bankAccountSteps,
        {id: 'Setup complete', content: 'Setup complete! That\'s all the information we need for now.', onNext: async () => {await loadData(stateRef.current.partner);}, submitIfNotNext: true, nextText: 'Finish'}
    ];

    const getStepContent = (step: number) => {
        if(stateRef.current.steps.length <= step){
            return '';
        }
        if(typeof(stateRef.current.steps[step].content) === 'function'){
            return stateRef.current.steps[step].content();
        }
        return stateRef.current.steps[step].content;
    }
    const getDisabled = (step: number) => {
        if(stateRef.current.steps.length > step && stateRef.current.steps[step].continueDisabled){
            return stateRef.current.steps[step].continueDisabled();
        }
        return false;
    }
    const goToNext = (extra?: any) => {
        setState({activeStep: stateRef.current.activeStep + 1, continueLoading: false, ...extra});
        window.scrollTo(0, 0);
    }
    const handleNext = async () => {
        let step = stateRef.current.steps[stateRef.current.activeStep];
        if(step.onNext && !(await step.onNext())){
            return;
        }
        goToNext();
    }
    const handleBack = () => {
        setState({activeStep: stateRef.current.activeStep - 1});
        window.scrollTo(0, 0);
    }

    useEffect(() => {
        (async () => {
            let partnerId = new Helpers().queryString()['partner'];
            let partners = (await axios.get(Config.api + `/api/v1/partners`)).data.Body.Partners;
            let partnerName = (partners.find((r: any) => r.Id.toString() === partnerId) || {}).CompanyName;
            await loadData(partnerId);
            setState({loaded: true, partnerName, partner: partnerId});
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Grid container spacing={2}>
        {state.loaded && !state.loadError && !state.accountSetup && <Grid size={12}>
        <Card>
            <Toolbar className='lbtoolbar'>Configure payment provider</Toolbar>
            <CardContent style={{display: 'flex', flexDirection: 'column'}}>
            <Stepper activeStep={state.activeStep}>
                {state.steps.map((step: any, index: number) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                      <Step key={index} {...stepProps}>
                        <StepLabel {...labelProps}>{step.id}</StepLabel>
                      </Step>
                    );
                  })}
            </Stepper>
            <div style={{textAlign: 'left'}}>
                {getStepContent(state.activeStep)}
            </div>
            <div style={{textAlign: 'left', paddingTop: '10px'}}>
            {state.activeStep !== 0 ? <Button variant='outlined' disabled={state.continueLoading} onClick={handleBack} style={{marginRight: '1em'}}>Back</Button> : ''}
            {state.activeStep !== state.steps.length - 1 && <DownloadButton variant='contained'  onClick={handleNext} loading={state.continueLoading} color='primary' disabled={getDisabled(state.activeStep)}>Continue</DownloadButton>}
            {state.activeStep === state.steps.length - 1 && state.steps[state.activeStep].submitIfNotNext && <DownloadButton variant='contained' onClick={handleNext} loading={state.continueLoading} color='primary' disabled={getDisabled(state.activeStep)}>{state.steps[state.activeStep].nextText || 'Submit'}</DownloadButton>}
            </div>
            </CardContent>
        </Card>
        </Grid>
        }
        {!state.loadError && state.accountSetup && <Grid size={{ md: 6, sm: 6, xs: 12 }}>
            {state.loaded ? <AccountInfo account={state.accountInfo} editAccountInfo={editAccountInfo}/> : <ContentLoader preserveAspectRatio='none' style={{height: '30em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
        </Grid>}
        {!state.loadError && state.accountSetup && <Grid size={{ md: 6, sm: 6, xs: 12 }}>
        <Grid container spacing={2} style={{alignContent: 'flex-start'}}>
            <Grid size={12}>
                {state.loaded ? <DocumentInfo documents={state.documents} uploadKyc={uploadKyc}/> : <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
            </Grid>
            <Grid size={12}>
                {state.loaded ? <UboInfo ubo={state.ubo} editUbo={editUbo}/> : <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
            </Grid>
            <Grid size={12}>
                {state.loaded ? <Card>
                    <Toolbar className='lbtoolbar'><span style={{flex: 1, textAlign: 'left'}}>{'Bank Accounts'}</span><Button onClick={newBankAccount} style={{color: 'white'}}>Create</Button></Toolbar>
                    <CardContent>
                    <Table>
                     <TableHead>
                        <TableRow>
                         <TableCell style={{width: '10em'}}>Type</TableCell>
                         <TableCell>Account Number</TableCell>
                         <TableCell style={{width: '8em'}}></TableCell>
                        </TableRow>
                     </TableHead>
                     <TableBody>
                         {state.bankAccounts.map((name: any, index: number) => <TableRow key={index}>
                             <TableCell>{state.bankAccounts[index].Type}</TableCell>
                             <TableCell>{state.bankAccounts[index].AccountNumber}</TableCell>
                             <TableCell><Button variant='outlined' onClick={() => deactivateBankAccount(state.bankAccounts[index].Id)}>Remove</Button></TableCell>
                         </TableRow>)}
                         {state.bankAccounts.length === 0 && <TableRow><TableCell colSpan={4}>You must have at least one bank account to receive payouts.</TableCell></TableRow>}
                     </TableBody>
                    </Table>
                    </CardContent>
                </Card> : <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
            </Grid>
            </Grid>
        </Grid>}
        {state.loadError && <>
            <Grid size={12}>
              <LoadErrorIcon style={{fontSize: '14rem', color: '#999'}}/>
            </Grid>
            <Grid size={12} style={{fontSize: '1.5rem', color: '#999'}}>{state.loadError}</Grid>
        </>}
        <Dialog maxWidth='md' open={state.showEditor} onClose={() => {setState({showEditor: false})}}>
            <Toolbar className='lbtoolbar'>{state.editorTitle}</Toolbar>
            <DialogContent>
            {state.steps.length > 1 && <Stepper activeStep={state.activeStep}>
                {state.steps.map((step: any, index: number) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                      <Step key={index} {...stepProps}>
                        <StepLabel {...labelProps}>{step.id}</StepLabel>
                      </Step>
                    );
                  })}
            </Stepper>}
            <Grid container spacing={2}>
                {getStepContent(state.activeStep)}
            </Grid>
            </DialogContent>
            <DialogActions>
                {state.activeStep !== 0 ? <Button disabled={state.continueLoading} onClick={handleBack} style={{marginRight: '1em'}}>Back</Button> : ''}
                {state.activeStep !== state.steps.length - 1 && <DownloadButton onClick={handleNext} loading={state.continueLoading} color='primary' disabled={getDisabled(state.activeStep)}>Continue</DownloadButton>}
                {state.activeStep === state.steps.length - 1 && state.steps[state.activeStep].submitIfNotNext && <DownloadButton onClick={handleNext} loading={state.continueLoading} color='primary' disabled={getDisabled(state.activeStep)}>Submit</DownloadButton>}
            </DialogActions>
        </Dialog>
        <Dialog open={state.showError} onClose={() => {setState({showError: false})}}>
            <Toolbar className='lbtoolbar'>{'Error'}</Toolbar>
            <DialogContent><Typography style={{whiteSpace: "pre-wrap"}}>{state.error}</Typography></DialogContent>
        </Dialog>
          <ConfirmDialog open={state.showConfirm} onClose={() => setState({showConfirm: false})} message={state.confirmContent} onConfirm={state.handleConfirm}/>
    </Grid>;
}

const RetailerView = (props: any) => {
    const [state, setStateRaw] = useState<any>({ partnerName: null, documents: [] });
    const stateRef = useRef<any>(state);
    const setState = (partial: any) => {
        const next = { ...stateRef.current, ...partial };
        stateRef.current = next;
        setStateRaw(next);
    };

    const loadUbo = async (partner: string) => {
        let declaration = (await axios.get(Config.api + `/api/v1/payment/${partner}/BeneficiaryDeclaration`)).data;
        if(declaration.Beneficiaries){
            declaration.Beneficiaries.forEach((r: any) => {
                if(r.Birthday){
                    r.Birthday = moment(r.Birthday).format('YYYY-MM-DD')
                }
            });
        }
        declaration.statusCode = 500;
        if(declaration.Status === 'Refused' ){
            declaration.statusCode = 1200;
        } else if (declaration.Status === 'Validated'){
            declaration.statusCode = 1000;
        }
        return declaration;
    }
    const loadDocuments = async (partner: string) => {
        return (await axios.get(Config.api + `/api/v1/payment/${partner}/documents`)).data;
    }
    const loadData = async (partner: string) => {
        if(!partner){
            return;
        }
        let accountInfo: any = {};
        try{
            accountInfo = (await axios.get(Config.api + `/api/v1/payment/${partner}/account`)).data;
            accountInfo = processAccountInfo(accountInfo);
        }catch(e: any){
            if(e.response && e.response.status === 404){
                // `allSteps` was never defined on RetailerView (only on PaymentSettings);
                // this pre-existing reference evaluated to undefined and is inert since
                // RetailerView never reads state.steps. Preserved as `undefined` rather
                // than "fixed" -- no observable behavior to change.
                setState({accountInfo: {}, loaded: true, loadError: 'This company does not have an account set up.', steps: undefined, activeStep: 0});
                return;
            }
            setState({loaded: true, loadError: 'Failed to load account information.', accountInfo: {}, documents: [], ubo: {}});
            return;
        }
        let documents = await loadDocuments(partner);

        let ubo: any = {};
        try {
            ubo = await loadUbo(partner);
        }catch(e){
            // do nothing
        }
        setState({accountInfo: accountInfo, loaded: true, loadError: null, documents, ubo});
    }

    useEffect(() => {
        (async () => {
            let partnerId = new Helpers().queryString()['partner'];
            let partners = (await axios.get(Config.api + `/api/v1/partners`)).data.Body.Partners;
            let partnerName = (partners.find((r: any) => r.Id.toString() === partnerId) || {}).CompanyName;
            await loadData(partnerId);
            setState({loaded: true, partnerName});
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Grid container spacing={2}>
        {!state.loadError && <Grid size={{ md: 6, sm: 6, xs: 12 }}>
            {state.loaded ? <AccountInfo account={state.accountInfo} partnerName={state.partnerName}/> : <ContentLoader preserveAspectRatio='none' style={{height: '30em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
        </Grid>}
        {!state.loadError && <Grid size={{ md: 6, sm: 6, xs: 12 }}>
        <Grid container spacing={2} style={{alignContent: 'flex-start'}}>
            <Grid size={12}>
                {state.loaded ? <DocumentInfo documents={state.documents}/> : <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
            </Grid>
            <Grid size={12}>
                {state.loaded ? <UboInfo ubo={state.ubo}/> : <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>}
            </Grid>
            </Grid>
        </Grid>}
        {state.loadError && <>
            <Grid size={12}>
              <LoadErrorIcon style={{fontSize: '14rem', color: '#999'}}/>
            </Grid>
            <Grid size={12} style={{fontSize: '1.5rem', color: '#999'}}>{state.loadError}</Grid>
        </>}
    </Grid>;
}

const AccountView = (props: any) => {
    useEffect(() => {
        if (props.setTitle) {
            props.setTitle('Payment Center');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if(props.isRetailer){
        return <RetailerView {...props}/>;
    } else if (Auth.hasPermission("settings/manage")){
        return <PaymentSettings {...props}/>;
    } else{
        return <RetailerView {...props}/>;
    }
}

export default PaymentSettings;

// AccountInfo exported for unit tests (the no-account null-guard).
export {AccountView, AccountInfo};
